import { createContext, useContext } from "react"
import { Data } from "@lottiefiles/dotlottie-react"

const StarAnimContext = createContext<Data | undefined>(undefined)

export const StarAnimProvider = ({ children, starAnim }: { children: React.ReactNode, starAnim?: Data }) => {
    return (
        <StarAnimContext.Provider value={starAnim}>
            {children}
        </StarAnimContext.Provider>
    )
}

export const useStarAnimContext = () => {
    return useContext(StarAnimContext)
}